import React from 'react';
import { Search, Filter, ArrowUpDown } from 'lucide-react';

interface SearchBarProps {
  searchTerm: string;
  onSearchChange: (term: string) => void;
  onFilterToggle: () => void;
  isFilterOpen: boolean;
  onSortToggle: () => void;
  isSortOpen: boolean;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  searchTerm,
  onSearchChange,
  onFilterToggle,
  isFilterOpen,
  onSortToggle,
  isSortOpen
}) => {
  return (
    <div className="relative flex items-center gap-3">
      <div className="relative flex-1">
        <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
        <input
          type="text"
          placeholder="Search businesses, locations, descriptions..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full pl-12 pr-4 py-3 bg-gray-800/50 border border-gray-700 rounded-xl text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-300"
        />
      </div>
      
      <button
        onClick={onSortToggle}
        className={`p-3 rounded-xl border transition-all duration-300 ${
          isSortOpen
            ? 'bg-orange-500 border-orange-500 text-white'
            : 'bg-gray-800/50 border-gray-700 text-gray-400 hover:bg-gray-700/50 hover:text-white'
        }`}
        title="Sort options"
      >
        <ArrowUpDown className="w-5 h-5" />
      </button>
      
      <button
        onClick={onFilterToggle}
        className={`p-3 rounded-xl border transition-all duration-300 ${
          isFilterOpen
            ? 'bg-orange-500 border-orange-500 text-white'
            : 'bg-gray-800/50 border-gray-700 text-gray-400 hover:bg-gray-700/50 hover:text-white'
        }`}
        title="Filter by category"
      >
        <Filter className="w-5 h-5" />
      </button>
    </div>
  );
};